import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import Sidebar from '../Containers/sideBar';
import ComponentLibrary from '../Components/ComponentLibrary/componentlibrary';

class Homepage extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }


  render() {
    return (
      <div className="Homepage View">
        <Sidebar>
        </Sidebar>
        <div className={this.props.sidebarShow ? "Container sideBarOn" : "Container sideBarOff"}>
          {/* <ComponentLibrary></ComponentLibrary> */}
        </div>
        
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    sidebarShow: state.appReducer.sidebarShow,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);


